import { UserProfileService } from '../services/user-profile.service';
import { environment } from '../../environments/environment';

export function initKeycloak(userProfileService: UserProfileService): () => Promise<void> {
  return () =>
    userProfileService.initKeycloak({
      config: {
        url: environment.keycloak.url,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId,
      },
      initOptions: {
        checkLoginIframe: false,
        onLoad: 'login-required',
        silentCheckSsoRedirectUri: `${window.location.origin}/assets/silent-check-sso.html`,
        silentCheckSsoFallback: false,
      },
      loadUserProfileAtStartUp: true,
      enableBearerInterceptor: true,
      bearerPrefix: 'Bearer',
    });
}
